<template>
    <div>
      <ForgotPassword/>
    </div>
</template>
  
<script>
  import ForgotPassword from "../components/ForgotPassword.vue";
  export default {
    name: 'ForgotView',
    components: {
      ForgotPassword
    }
  }
</script>